;
(function ($) {
    $(document).ready(function () {

        // setTimeout(function () {
        //     $('.slick-slider .slick-slide').each(function () {
        //         console.log('hi');
        //         $(this).addClass('hello1');
        //         if ($(this).find('.show-desktop').length > 0) {
        //             $(this).addClass('hello');
        //             $(this).remove(); // Remove this entire slide
        //         }
        //     });
        // }, 5000); // 5000 milliseconds = 5 seconds


        // $('.slick-slider').on('init', function () {
        //     setTimeout(function () {
        //         $('.slick-slider .slick-slide').each(function () {
        //             console.log('hi');
        //             $(this).addClass('hello1'); // Adds the class 'hello1' to each slide
        //             if ($(this).find('.show-desktop').length > 0) { // Checks if 'show-desktop' class exists inside the slide
        //                 $(this).addClass('hello'); // Adds the class 'hello' to the slide
        //                 $(this).remove(); // Removes the slide
        //             }
        //         });
        //     }, 5000); // 5000 milliseconds = 5 seconds
        // });





    });
})(jQuery);